var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 2.66675H7.99984C7.29259 2.66675 6.61432 2.9477 6.11422 3.4478C5.61412 3.94789 5.33317 4.62617 5.33317 5.33341V9.33342H2.6665V12.0001H5.33317V14.6667H2.6665V17.3334H5.33317V20.0001H2.6665V22.6667H5.33317V26.6667C5.33317 27.374 5.61412 28.0523 6.11422 28.5524C6.61432 29.0525 7.29259 29.3334 7.99984 29.3334H27.9998C28.3535 29.3334 28.6926 29.1929 28.9426 28.9429C29.1927 28.6928 29.3332 28.3537 29.3332 28.0001V4.00008C29.3332 3.64646 29.1927 3.30732 28.9426 3.05727C28.6926 2.80722 28.3535 2.66675 27.9998 2.66675ZM17.3332 6.66541C19.5305 6.66541 21.3332 8.46675 21.3332 10.6654C21.3293 11.7252 20.9067 12.7405 20.1574 13.49C19.4081 14.2396 18.393 14.6625 17.3332 14.6667C15.1372 14.6667 13.3332 12.8627 13.3332 10.6654C13.3332 8.46675 15.1372 6.66541 17.3332 6.66541ZM25.3332 24.0001H9.33317V23.0001C9.33317 20.0414 12.9398 17.0001 17.3332 17.0001C21.7265 17.0001 25.3332 20.0414 25.3332 23.0001V24.0001Z",
    fill: "#17255A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIcon);
export default __webpack_public_path__ + "static/media/contactUsIcon.69b660657931e8674bde0d79e9378ec9.svg";
export { ForwardRef as ReactComponent };